import {
    MapOptions
} from "esdm-map/dist";
import { NorthantsBaseLayerTypes } from "./NorthantsBaseMapping_3857";

export class DefaultMapOptions {

    public static GetDefaultOptions(
        mapElementId: string,
        mapStoreKey: string
    ): MapOptions {       

        let opt = new MapOptions();       
        opt.bingApiKey = $(`#${mapElementId}`).data("bing-api-key");
        opt.esdmOsmApiKey = $(`#${mapElementId}`).data("esdm-osm-api-key");
        opt.baseMaps = [
            NorthantsBaseLayerTypes.NorthamptonshireOS,
            NorthantsBaseLayerTypes.NorthamptonshireAerial,
            NorthantsBaseLayerTypes.NorthamptonshireOS6inch,
            NorthantsBaseLayerTypes.NorthamptonshireEALidar
        ];
        opt.defaultBaseMap = NorthantsBaseLayerTypes.NorthamptonshireOS;
        opt.enableBoundsTracking = true;
        opt.zoomToNearestBounds = false;
        opt.maxZoomToBounds = 18;
        opt.mapElementId = mapElementId;
        opt.mapStoreKey = mapStoreKey;
        opt.mapZoom = 13;
        opt.minZoom = 9;
        opt.maxZoom = 18;
        
        opt.extent = [-148400, 6796000, -38000, 6917400];
        opt.mapCentre = [
            //Northampton
            -99793, 6843309
        ];    

        opt.displayProjection = "EPSG:3857";
        opt.dataProjection = "EPSG:27700";
        opt.dragRotateAndZoom = false;                
        return opt;
    }

}
